// extracted by mini-css-extract-plugin
export default {"btn":"KALENDARZ_BTN_btn__bFLAt","icon":"KALENDARZ_BTN_icon__uRE9B"};